import { render } from "./SaleSharedExpensesTab.vue?vue&type=template&id=712db596&scoped=true"
import script from "./SaleSharedExpensesTab.vue?vue&type=script&lang=js"
export * from "./SaleSharedExpensesTab.vue?vue&type=script&lang=js"

import "./SaleSharedExpensesTab.vue?vue&type=style&index=0&id=712db596&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712db596"]])

export default __exports__